export default __webpack_public_path__ + "fonts/contact-profile-empty.svg";